import React from "react";
import Layout from "../../layouts/Layout";
import IconRegister from "../../components/icons/icon-register";
import Box from "@mui/material/Box";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormGroup from "@mui/material/FormGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import DialogContentText from "@mui/material/DialogContentText";
import TextFieldSC from "../../components/TextFieldSC";
import DesktopDatePickerSC from "../../components/DesktopDatePickerSC";
import SelectSC from "../../components/SelectSC";
import IconButton from "@mui/material/IconButton";

import moment from "moment";
import ProfileImage from "./ProfileImage";
import Notification from "../../services/notification.service";
import { useNavigate } from "react-router-dom";
import Dropzone from "../../components/Dropzone";
import UploadFileIcon from "@mui/icons-material/UploadFile";
import CheckIcon from "@mui/icons-material/Check";
import { GoPlus } from "react-icons/go";
import apiService from '../../utils/api.service';
import helper from '../../utils/helper';
import BButton from '../../components/general/BButton';
import FileUpload from "../../components/icons/FileUpload";
import { connect } from "react-redux";
import actions from "../../redux/actions";
import { IMaskInput } from 'react-imask';
import Input from '@mui/material/Input';
import _ from "lodash"
import TextMaskIdCard from "../../components/general/TextMaskIdCard"
import TextMaskLicenseNo from "../../components/general/TextMaskLicenseNo"
import TextMaskBank from "../../components/general/TextMaskBank"
import AccessibleIcon from "@mui/icons-material/Accessible";
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import dayjs from 'dayjs';
import 'dayjs/locale/en';
import 'dayjs/locale/th';

class EditProfile extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false,
      openType: '',
      isSubmit: false,
      error: {},
      errLen10: false,
      errLen13: false,
      imageProfile: null,
      imageName: '',
      resumeFile: null,
      resumeName: '',
      data: {
        memberCode: '',
        firstName: '',
        lastName: '',
        idCard: '',
        birthday: null,
        phone: '',
        email: '',
        address: '',
        licenseNumber: '',
        position: '',
        educationalQualification: '',
        referralCode: '',
        bank: '',
        bankAccountNumber: '',
      },
      reasonsList: [
        { text: "ทำงาน ทำงาน ทำงาน", value: "1" },
        { text: "ทำใจ ทำใจ ทำใจ", value: "2" },
        { text: "deploy deploy deploy", value: "3" },
      ],
      imageErr: false,
      resumeErr: false,
      loading: false,
    };
  }

  componentDidMount() {
    this.LoadProfile()
  }

  getData() {
    this.setState({ loading: true,});
  }
  
  async LoadProfile() {
    try {
      this.setState({ loading: true });
      const payload = { memberId: this.props?.user?.lineId?.memberId }
      const header = helper.GEN.toValueHeader(this.props)
      const { resData } = await apiService.Profile.SearchMember(payload, header)
      this.setState({ loading: false });
      if (resData.resultCode === "20000") {
        const Resdata = _.cloneDeep(resData.data)
        // console.log('data >>', data)
        let { imageProfile, resumeFile, data  } = this.state
        data.memberCode = Resdata.memberCode
        data.firstName = Resdata.firstName
        data.lastName = Resdata.lastName
        data.idCard = Resdata.identificationNo
        data.birthday = Resdata.birthDate
        data.phone = Resdata.phone ?? '0907412265'
        data.email = Resdata.email ?? 'pukpui15s@gmail.com'
        data.address = Resdata.address ?? '14 m4 campson'
        data.licenseNumber = Resdata.licenseNo
        data.position = Resdata.position || ''
        data.educationalQualification = Resdata.education || ''
        data.referralCode = Resdata.recommenderCode
        data.bank = Resdata.bank
        data.bankAccountNumber = Resdata.bankAccountNo
        imageProfile = Resdata.picture
        resumeFile = Resdata.resumeFile

        data = { ...data, ...this.checkboxArrayToObj(Resdata, 'reason')}
        console.log('data >>', data)
        this.setState({ data, imageProfile, resumeFile })
      }
    }
    catch(e){
      console.log('API ERR', e)
    }
  }
  changeValue(e, type, targetValue = "target") {
    let value = null;
    if (targetValue === "target") {
      value = e.target.value;
    } else if (targetValue === "checked") {
      value = e.target.checked;
    } else {
      value = e;
    }

    let { data } = this.state;
    const nextState = data;
    nextState[type] = value;
    this.checkValidation(nextState);
    this.setState({ data: nextState });
  }

  checkValidation(data) {
    if (!this.state.isSubmit) {
      return false;
    }
    let error = this.state.error;
    let required = [
      "firstName",
      "lastName",
      "idCard",
      "birthday",
      "phone",
      "email",
      "address",
      "licenseNumber",
      "position",
      // "educationalQualification",
      // "referralCode",
      "bank",
      "bankAccountNumber",
    ];
    let hasError = false;
    for (var i in data) {
      if (!data[i] && required.indexOf(i) > -1) {
        error[i] = true;
        hasError = true;
      } else {
        error[i] = false;
      }
    }
    this.setState({ error: error });
    return hasError;
  }

  async onSave() {
    let hasError = this.checkValidation(this.state.data);
    console.log("this.state.data", this.state.data);
    const { data, imageProfile, resumeFile } = this.state
    const { errLen10, errLen13 } = this.state
    const memberId =  this.props?.user?.lineId?.memberId
    if (!hasError && !errLen10 && !errLen13 && resumeFile) {
      // const resumeFileURL = await this.uploadImage(resumeFile)
      const resumeFileURL = resumeFile
      const payload = {
        memberId: memberId,
        firstName: data.firstName,
        lastName: data.lastName,
        identificationNo: data.idCard,
        birthDate: moment(data.birthday.$d || data.birthday).format('YYYY-MM-DD'),
        phone: data.phone,
        email: data.email,
        address: data.address,
        licenseNo: data.licenseNumber,
        position: data.position,
        education: data.educationalQualification,
        resumeFile: resumeFileURL,
        reason: helper.FN.toArrayNumber(this.checkboxObjToArray(data, 'reason')),
        bank: data.bank,
        bankAccountNo: data.bankAccountNumber,
        picture: imageProfile
      }
      this.updateProfile(payload);
    } else {
      this.setState({ resumeErr: true })
    }
  }

  checkboxArrayToObj(obj,name){
    let temp = {}
    if(obj[name] && obj[name].length){
      let arr = obj[name]
      for(let i in arr){
        temp[name+"["+arr[i]+"]"] = true;
      }
    }
    return temp;
  }

  checkboxObjToArray(obj,name){
    let temp = {}
    temp[name] = [];
    for(let i in obj) {
      if (i.toString().indexOf(name) > -1) {
        if (obj[i]) {
          temp[name].push(i.toString().replace(name+"[","").replace("]",""))
        }
      }  
    }
    return temp[name]
  }

  async uploadImage(file = '') {
    return  new Promise(async (resolve, reject) => {
      try {
        this.setState({ loading: true });
        const { resData } = await apiService.External.UploadFile({ file: file })
        this.setState({ loading: false });
        resolve(resData.URL)
      }
      catch(e){
        console.log('API uploadImage ERR', e)
      }
    });
  }

  async updateProfile(payload = {}) {
    try {
      this.setState({ loading: true });
      const header = helper.GEN.toValueHeader(this.props)
      const { resData } = await apiService.Profile.UpdateMember(payload, header)
      this.setState({ loading: false });
      if (resData.resultCode === "20000") {
        Notification.success({ 
          title: "Success!", description: "บันทึกสำเร็จ" , 
          onCancel: () => { this.props.navigate(`/profile`) } 
        });
      } else {
        Notification.error({ title: "ขออภัย", description: "รหัสผู้แนะนำไม่ถูกต้อง กรุณาตรวจสอบข้อมูลอีกครั้ง" });
      }
    }
    catch(e){
      console.log('API ERR', e)
    }
  }

  render() {
    let { error, data, imageErr, resumeErr } = this.state;
    let { isSubmit, errLen10, errLen13 } = this.state;
    const { option } = this.props
    return (
      <Layout>
        <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale={'th'}>
          <div className="main-header">
            <div className="main-header-text">แก้ไขข้อมูล</div>
          </div>
          <div className="main-body">
            <div className="row">
              <div className="col-xs-12" style={{ textAlign: "center" }}>
                <Dropzone
                  onDrop={(file) => {
                    console.log("file >>", file);
                    console.log("file[0].size", file.file[0].size);
                    const MAXSIZEFILE = helper.CONFIG.MAXSIZEFILE
                    const IMGTYPEFILE = helper.CONFIG.IMGTYPEFILE
                    console.log("MAXSIZEFILE", MAXSIZEFILE);
                    if (IMGTYPEFILE.includes(file.file[0]?.type) && file.file[0]?.size <= MAXSIZEFILE) {
                      this.setState({ imageErr: false, imageProfile: file.base64, imageName: file.file[0].name });
                    } else {
                      this.setState({ imageErr: true, imageProfile: null, imageName: '' });
                    }
                  }}
                  isDropSuccess={this.state.imageProfile}
                  closeStyle={'circle'}
                  onClose={()=> {
                    this.setState({ imageProfile: null, imageName: '' });
                  }}
                  dropUI={
                    <>
                    <div className="upload-profile">
                     <div className="icon">
                        <svg width="44" height="44" viewBox="0 0 44 44" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M40.8571 17.2857H26.7143V3.14286C26.7143 1.40741 25.3069 0 23.5714 0H20.4286C18.6931 0 17.2857 1.40741 17.2857 3.14286V17.2857H3.14286C1.40741 17.2857 0 18.6931 0 20.4286V23.5714C0 25.3069 1.40741 26.7143 3.14286 26.7143H17.2857V40.8571C17.2857 42.5926 18.6931 44 20.4286 44H23.5714C25.3069 44 26.7143 42.5926 26.7143 40.8571V26.7143H40.8571C42.5926 26.7143 44 25.3069 44 23.5714V20.4286C44 18.6931 42.5926 17.2857 40.8571 17.2857Z" fill="#DADADA"/>
                        </svg>
                      </div>
                      <div className="txt"> อัปโหลดรูปภาพ</div>
                    </div>
                    { 
                      imageErr &&
                      <div className="err-img">
                        <div>สามารถอัพโหลดไฟล์ .jpg .jpeg .png เท่านั้น</div>
                        <div>ขนาดไฟล์ไม่เกิน 1 MB</div>
                      </div>
                    }
                    </>
                  }
                  dropSuccessUI={
                    <div>
                      <img
                        src={this.state.imageProfile}
                        alt="profile"
                        style={{ 
                          width: "141px", height: "141px", 
                          borderRadius: "50%", objectFit: "cover", 
                          cursor: "pointer" 
                        }}
                      />
                      { 
                        imageErr &&
                        <div className="err-img">
                          <div>สามารถอัพโหลดไฟล์ .jpg .jpeg .png เท่านั้น</div>
                          <div>ขนาดไฟล์ไม่เกิน 1 MB</div>
                        </div>
                      }
                    </div>
                  }
                />
              </div>
              <div className="col-xs-12">
                <Box
                  component="form"
                  sx={{}}
                  noValidate
                  autoComplete="off"
                  className="form-save"
                >
                  <div className="row">
                    <div className="col-xs-12">
                      <div className="main-body-header">ข้อมูลส่วนตัว</div>
                    </div>
                    <div className="col-xs-12">
                      <div className="main-body-subheader">
                        เลขที่สมาชิก : {data.memberCode}
                      </div>
                    </div>

                    <div className="col-xs-6 col-div">
                      <TextFieldSC
                        label="ชื่อ"
                        id="firstName"
                        variant="standard"
                        required={true}
                        fullWidth
                        error={error.firstName}
                        value={data.firstName}
                        onChange={(e) => this.changeValue(e, "firstName")}
                      />
                    </div>
                    <div className="col-xs-6 col-div">
                      <TextFieldSC
                        label="นามสกุล"
                        id="lastName"
                        variant="standard"
                        required={true}
                        fullWidth
                        error={error.lastName}
                        value={data.lastName}
                        onChange={(e) => this.changeValue(e, "lastName")}
                      />
                    </div>
                    <div className="col-xs-12 col-div">
                      <TextFieldSC
                        label="เลขที่บัตรประชาชน"
                        id="idCard"
                        variant="standard"
                        required={true}
                        fullWidth
                        value={data.idCard}
                        error={error.idCard || (isSubmit && errLen13)}
                        onChange={(e) => {
                          this.changeValue(e, "idCard")
                          this.setState({ errLen13 : helper.CKFORM.cardID(e.target?.value)})
                        }}
                        InputProps={{ inputComponent: TextMaskIdCard }}
                      />
                    </div>
                    <div className="col-xs-12 col-div">
                      <DesktopDatePickerSC
                        error={error.birthday}
                        value={data.birthday}
                        required={true}
                        onChange={(e) =>
                          this.changeValue(e, "birthday", "value")
                        }
                        label="วัน เดือน ปีเกิด"
                        inputFormat="DD/MM/YYYY"
                        renderInput={(params) => (
                          <TextFieldSC variant="standard" fullWidth {...params} />
                        )}
                        components={{
                          OpenPickerIcon: CalendarMonthIcon
                        }}
                      />
                    </div>

                    <div className="col-xs-12 col-div">
                      <TextFieldSC
                        error={error.phone}
                        value={data.phone}
                        required={true}
                        onChange={(e) => this.changeValue(e, "phone")}
                        label="เบอร์โทรศัพท์"
                        id="phone"
                        variant="standard"
                        fullWidth
                      />
                    </div>

                    <div className="col-xs-12 col-div">
                      <TextFieldSC
                        error={error.email}
                        value={data.email}
                        required={true}
                        onChange={(e) => this.changeValue(e, "email")}
                        label="อีเมล"
                        id="email"
                        variant="standard"
                        fullWidth
                      />
                    </div>

                    <div className="col-xs-12 col-div">
                      <TextFieldSC
                        error={error.address}
                        value={data.address}
                        required={true}
                        onChange={(e) => this.changeValue(e, "address")}
                        label="ที่อยู่"
                        id="address"
                        variant="standard"
                        fullWidth
                      />
                    </div>
                    <div className="col-xs-12 col-div">
                      <TextFieldSC
                        error={error.licenseNumber || (isSubmit && data.licenseNumber?.length < 10)}
                        value={data.licenseNumber}
                        required={true}
                        onChange={(e) => this.changeValue(e, "licenseNumber")}
                        label="เลขที่ใบประกอบวิชาชีพ"
                        id="licenseNumber"
                        variant="standard"
                        fullWidth
                        InputProps={{ inputComponent: TextMaskLicenseNo }}
                      />
                    </div>

                    <div className="col-xs-12 col-div">
                      <SelectSC
                        error={error.position}
                        value={data.position}
                        onChange={(e) =>
                          this.changeValue(e, "position")
                        }
                        required={true}
                        labelId="position"
                        id="position"
                        label="ตำแหน่ง"
                        variant="standard"
                        fullWidth
                        displayEmpty
                      >
                        <MenuItem disabled value="">ตำแหน่ง<span className="txt-err">*</span></MenuItem>
                        {
                          option.position.map((item,index) => (
                            <MenuItem key={index} value={item.id}>{item.name}</MenuItem>
                          ))
                        }
                      </SelectSC>
                    </div>

                    <div className="col-xs-12 col-div">
                      <SelectSC
                        error={error.educationalQualification}
                        value={data.educationalQualification}
                        onChange={(e) =>
                          this.changeValue(e, "educationalQualification")
                        }
                        required={true}
                        labelId="educationalQualification"
                        id="educationalQualification"
                        label="วุฒิการศึกษา"
                        variant="standard"
                        fullWidth
                        displayEmpty
                      >
                        <MenuItem disabled value="">วุฒิการศึกษา</MenuItem>
                        {
                          option.education.map((item,index) => (
                            <MenuItem key={index} value={item.id}>{item.name}</MenuItem>
                          ))
                        }
                      </SelectSC>
                    </div>

                    {/* <div className="col-xs-12 col-div">
                      <TextFieldSC
                        error={error.referralCode}
                        value={data.referralCode}
                        onChange={(e) => this.changeValue(e, "referralCode")}
                        label="รหัสแนะนำ"
                        id="referralCode"
                        variant="standard"
                        fullWidth
                      />
                    </div> */}

                    <div className="col-xs-12">
                      <div className="main-body-header">ข้อมูลการทำงาน</div>
                      <div className="profile-history">ประวัติการทำงาน<span className="txt-err">*</span></div>
                    </div>
                    <div className="col-xs-12 col-div">
                      <Dropzone
                        onDrop={(file) => {
                          console.log("file", file);
                          console.log("file[0].size", file.file[0].size);
                          const RESUMEMAXSIZEFILE = helper.CONFIG.RESUMEMAXSIZEFILE
                          const RESUMETYPEFILE = helper.CONFIG.RESUMETYPEFILE
                          console.log("RESUMEMAXSIZEFILE", RESUMEMAXSIZEFILE);
                          if (RESUMETYPEFILE.includes(file.file[0]?.type) && file.file[0]?.size <= RESUMEMAXSIZEFILE) {
                            this.setState({ resumeErr: false, resumeFile: file.base64, resumeName: file.file[0].name });
                          } else {
                            this.setState({ resumeErr: true, resumeFile: null, resumeName: '' });
                          }
                        }}
                        closeStyle={'resume'}
                        onClose={()=> {
                          this.setState({ resumeFile: null, resumeName: '' });
                        }}
                        dropUI={
                          <>
                            <div className={`want-resume ${resumeErr? 'err' : '' }`}>
                              <h5>กรุณาแนบ Resume</h5>
                              <div className="icon"><FileUpload /></div>
                            </div>
                            { 
                              resumeErr &&
                              <div className="err-img">
                                <div>- สามารถอัพโหลดไฟล์ .jpg .jpeg .pdf เท่านั้น</div>
                                <div>- ขนาดไฟล์ไม่เกิน 10 MB</div>
                              </div>
                            }
                          </>
                        }
                        isDropSuccess={this.state.resumeFile}
                        dropSuccessUI={
                          <div className="want-resume active">
                            <h5>Resume</h5>
                            <div className="icon"><FileUpload /></div>
                          </div>
                        }
                      />
                    </div>
                    <div className="col-xs-12 col-div">
                      <div className="main-field-header">
                        เหตุผลที่ต้องการใช้งาน Nurse
                      </div>

                      <div className="main-field-subheader">
                        สามารถเลือกได้มากกว่า 1 ข้อ
                      </div>

                      <FormGroup>
                        {!this.state.loading
                          ? option.nurseReason.map((r, i) => {
                              return (
                                <FormControlLabel
                                  control={
                                    <Checkbox
                                      sx={{
                                        "& .MuiSvgIcon-root": { fontSize: 28 },
                                      }}
                                      checked={data[`reason[${r.id}]`]}
                                      onChange={
                                        (e) => this.changeValue( e,`reason[${r.id}]`,"checked")
                                      }
                                    />
                                  }
                                  label={r.name}
                                />
                              );
                            })
                          : null}
                      </FormGroup>
                    </div>
                    <div className="col-xs-12">
                      <div className="main-body-header">ข้อมูลบัญชีธนาคาร</div>
                    </div>
                    <div className="col-xs-12 col-div">
                      <SelectSC
                        error={error.bank}
                        value={data.bank}
                        onChange={(e) => this.changeValue(e, "bank")}
                        labelId="bank"
                        id="bank"
                        label="ธนาคาร"
                        variant="standard"
                        fullWidth
                        displayEmpty
                      >
                        <MenuItem disabled value="">ธนาคาร<span className="txt-err">*</span></MenuItem>
                        {
                          option.bank.map((item,index) => (
                            <MenuItem key={index} value={item.id}>{item.name}</MenuItem>
                          ))
                        }
                      </SelectSC>
                    </div>
                    <div className="col-xs-12 col-div">
                      <TextFieldSC
                        value={data.bankAccountNumber}
                        error={error.bankAccountNumber || (isSubmit && errLen10)}
                        onChange={(e) => {
                          this.changeValue(e, "bankAccountNumber")
                          this.setState({ errLen10 : helper.CKFORM.textLen(e.target?.value, 12)})
                        }}
                        label="เลขที่บัญชีธนาคาร"
                        id="bankAccountNumber"
                        variant="standard"
                        required={true}
                        fullWidth
                        InputProps={{ inputComponent: TextMaskBank }}
                      />
                    </div>
                  </div>
                  <div className="dual-button">
                      <BButton setStyle="outline block mini" onClick={() => this.props.navigate(`/profile`)} >ยกเลิก</BButton>
                      <BButton setStyle="block mini" onClick={() => {
                        this.setState({ isSubmit: true },() => { this.onSave() });
                      }}>บันทึก</BButton>
                    </div>
                </Box>
              </div>
            </div>
          </div>
        </LocalizationProvider>
      </Layout>
    );
  }
}

function EditProfileRoute(props) {
  let navigate = useNavigate();
  return <EditProfile navigate={navigate} {...props}/>
}

const mapStateToProps = (state) => {
  return {
    ...state,
  };
};

export default connect(mapStateToProps, actions)(EditProfileRoute);


